import actions from './actions';
import mutations from './mutations';

const state = {
  user: {},
  displayLoginModal: false,
  haveNotes: false,
  nick: true,
  invite: '',
  friendsData: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
